var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('a',{staticClass:"socialAnchor bb-iconColor",attrs:{"rel":"noopener noreferrer","href":_vm.href,"target":"_blank"},domProps:{"innerHTML":_vm._s(_vm.icon)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }